/**
 * @generated SignedSource<<226f0c0a4ab501bd7047298a0762df3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeSeriesChart$data = {
  readonly dimensions: ReadonlyArray<{
    readonly color: string | null;
    readonly id: string;
    readonly label: string;
  }>;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly date: string;
      readonly formattedDate: string;
      readonly values: ReadonlyArray<{
        readonly dimensionId: string;
        readonly value: number | null;
      }>;
    };
  }>;
  readonly " $fragmentType": "TimeSeriesChart";
};
export type TimeSeriesChart$key = {
  readonly " $data"?: TimeSeriesChart$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesChart">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSeriesChart",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsNodeDimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSeriesAnalyticsNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formattedDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSeriesAnalyticsNodeDimensionValue",
              "kind": "LinkedField",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "dimensionId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSeriesAnalyticsConnection",
  "abstractKey": null
};

(node as any).hash = "cc17c216463bc9bf041251c8a65789ac";

export default node;
